import Icon from 'components/atoms/Icon';
import * as React from 'react';

export type ProgressRadialProps = {
	reach: number;
	total: number;
	text?: string;
	icon?: string;
	meterColor?: string;
	valueColor?: string;
	percent: number;
	modifiers?: Array<string>;
};

const strokeBaseValue = 389.557489;

const ProgressRadial = ({
	reach,
	total,
	text,
	icon,
	meterColor = '0099A6',
	valueColor = '48BFA2',
	percent,
	modifiers = [],
}: ProgressRadialProps) => {
	const percentCircleValue = percent > 100 ? 100 : percent;
	const offset = strokeBaseValue * (1 - percentCircleValue / 100);
	const classNames = ['m-progress-radial', ...modifiers.map((mod) => `m-progress-radial--${mod}`)];

	return (
		<div className={classNames.join(' ')}>
			<div className="m-progress-radial__info">
				<div className="m-progress-radial__info-title">
					<span className="m-progress-radial__info-title-reach">{reach}</span>
					<span className="m-progress-radial__info-title-slash">/</span>
					<span className="m-progress-radial__info-title-total">{total}</span>
				</div>
				{text ? <div className="m-progress-radial__info-text">{text}</div> : null}
				{icon ? (
					<div className="m-progress-radial__info-icon">
						<Icon iconName={icon} />
					</div>
				) : null}
			</div>
			<svg className="m-progress-radial__figure" width="134" height="134" viewBox="0 0 134 134">
				<circle
					className="m-progress-radial__meter"
					cx="67"
					cy="67"
					r="62"
					fill="transparent"
					stroke={`#${meterColor}`}
				/>
				<circle
					className="m-progress-radial__value"
					cx="67"
					cy="67"
					r="62"
					fill="transparent"
					stroke={`#${valueColor}`}
					style={{
						strokeDasharray: strokeBaseValue,
						strokeDashoffset: offset,
					}}
				/>
			</svg>
		</div>
	);
};

export default ProgressRadial;
